export const UPSELL_URL_EN: string =
  'https://recruiting.xing.com/en/e-recruiting-solutions/employerbrandingprofile';
export const UPSELL_URL_DE: string =
  'https://recruiting.xing.com/de/Arbeitgeberprofil-Upgrade';

type GetMarketingPageUrl = {
  locale: string;
  moduleName: string;
  focusType?: string;
  component?: string;
};

export const getMarketingPageUrl = ({
  locale,
  moduleName,
  focusType,
  component = '',
}: GetMarketingPageUrl) => {
  let url = locale === 'en' ? UPSELL_URL_EN : UPSELL_URL_DE;

  if (focusType === 'COMPANY' && moduleName) {
    url += `?sc_o=entity_page_companies_start_upsell_${moduleName}`;

    if (component.length) {
      url += `_${component}`;
    }
  }
  return url;
};
